import React from 'react';
import { makeStyles, Fab, CssBaseline, AppBar, Toolbar, Typography, IconButton } from '@material-ui/core';
import AppDrawer from './Drawer'
//icons
import MenuIcon from '@material-ui/icons/Menu';
import SendIcon from '@material-ui/icons/Send';
import AddIcon from '@material-ui/icons/Add';


const useStyles = makeStyles(theme => ({
    appBar: {
        top: 'auto',
        bottom: 0,
        zIndex: theme.zIndex.drawer + 1,
    },
    fabButton: {
        position: 'absolute',
        zIndex: 1,
        top: -30,
        left: 0,
        right: 0,
        margin: '0 auto',
    },
    grow: {
        flexGrow: 1,
    }
}));


const MyAppBar: React.FC<{ onSend: () => void }> = (props) => {
    const classes = useStyles();

    const [drawerIsOpen, setDrawerIsOpen] = React.useState<boolean>(false);


    return (
        <div>
            <CssBaseline />
            <AppBar position="fixed" className={classes.appBar}>

                <Toolbar className={classes.appBar}>
                    <IconButton
                        color="inherit"
                        aria-label="Open drawer"
                        onClick={() => setDrawerIsOpen(true)}
                        edge="start">
                        <MenuIcon />
                    </IconButton>
                    <Fab color="secondary" aria-label="Add" className={classes.fabButton} href="./#/detail/new/*">
                        <AddIcon />
                    </Fab>
                    <div className={classes.grow} />{/* центральный наполнитель*/}
                    <IconButton edge="end" color="inherit" onClick={() => props.onSend()}>
                        <Typography variant='body1' color='inherit'>отпр.</Typography>
                        <SendIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <AppDrawer
                state={drawerIsOpen}
                onClose={() => setDrawerIsOpen(false)} />
        </div >
    );
}
export default MyAppBar;
